import React from 'react';

const OccupationCertifications = ({
  title,
  element,
  hasData,
  data,
  handleChooseElements,
  handleAddElements,
  viewOnly
}) => {
  if (!data || (Array.isArray(data) && data.length === 0)) {
    if (hasData) {
      return (
        <div className="card h-100 mb-4">
          <div className="card-header h5 mb-0">
            {title}
          </div>
          <div className="card-body">
            No certificates required.
          </div>
          <div className="card-footer">
            {!viewOnly && (
              <button
                type="button"
                className="btn btn-sm btn-primary"
                onClick={handleChooseElements}
              >
                Choose
                {' '}
                {title}
              </button>
            )}
          </div>
        </div>
      );
    }

    return null;
  }

  return (
    <div className="card h-100 mb-4">
      <div className="card-header h5 mb-0">
        {title}
      </div>
      <div
        className="d-flex justify-content-between align-items-center border-bottom px-3 py-2"
      >
        <div>
          {element}
        </div>
        <div>
          Type
        </div>
      </div>
      <div className="card-body">
        {data.map((certificate, i) => {
          const {
            Description,
            // Id,
            Name,
            // Organization,
            // OrganizationAddress,
            // OrganizationUrl,
            Type
          } = certificate;
          return (
            <div
              key={`certificate-${i}`}
              className="d-flex justify-content-between align-items-center mb-4"
            >
              <div className="left d-flex align-items-center">
                <div className="text pr-3">
                  <h6 className="mb-0 d-flex align-items-center">
                    <span>
                      {Name}
                    </span>
                    <span className="dot dot-sm ms-2 bg-indigo" />
                  </h6>
                  <div className="text-muted">
                    {Description}
                  </div>
                </div>
              </div>
              <div className="right ms-5 ms-sm-0 ps-3 ps-sm-0">
                <div className="font-weight-bold">
                  {Type}
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <div className="card-footer d-flex justify-content-between align-items-center d-print-none">
        {!viewOnly && (
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={handleChooseElements}
          >
            Choose
            {' '}
            {title}
          </button>
        )}
        {!viewOnly && handleAddElements && (
          <button
            type="button"
            className="btn btn-sm btn-outline-primary"
            onClick={handleAddElements}
          >
            Add {title}
          </button>
        )}
      </div>
    </div>
  );
};

export default OccupationCertifications;
